import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=731e2b20&scoped=true&"
import script from "./NoResult.vue?vue&type=script&lang=js&"
export * from "./NoResult.vue?vue&type=script&lang=js&"
import style0 from "./NoResult.vue?vue&type=style&index=0&id=731e2b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e2b20",
  null
  
)

export default component.exports